import apiService from './api.service';

export interface Application {
  id: string;
  tenant_id: string;
  name: string;
  description?: string;
  api_key: string;
  public_api_key: string;
  environment: 'development' | 'staging' | 'production';
  language?: string;
  framework?: string;
  status: 'active' | 'inactive';
  settings?: object;
  created_at: string;
  updated_at: string;
}

export interface CreateApplicationRequest {
  name: string;
  description?: string;
  language: string;
  framework?: string;
  environment: 'development' | 'staging' | 'production';
}

export interface UpdateApplicationRequest {
  name?: string;
  description?: string;
  language?: string;
  framework?: string;
  environment?: 'development' | 'staging' | 'production';
  status?: 'active' | 'inactive' | 'archived';
}

class ApplicationApi {
  async getAll(): Promise<{ success: boolean; data: Application[] }> {
    return apiService.get('/v1/applications');
  }

  async getById(id: string): Promise<{ success: boolean; data: Application }> {
    return apiService.get(`/v1/applications/${id}`);
  }

  async create(data: CreateApplicationRequest): Promise<{ success: boolean; data: Application }> {
    return apiService.post('/v1/applications', data);
  }

  async update(id: string, data: UpdateApplicationRequest): Promise<{ success: boolean; data: Application }> {
    return apiService.put(`/v1/applications/${id}`, data);
  }

  async delete(id: string): Promise<{ success: boolean; message: string }> {
    return apiService.delete(`/v1/applications/${id}`);
  }

  async regenerateApiKey(id: string): Promise<{ success: boolean; data: Application }> {
    return apiService.post(`/v1/applications/${id}/regenerate-key`);
  }

  async getAvailable(): Promise<{ success: boolean; data: Application[] }> {
    return apiService.get('/v1/applications/available');
  }
}

export default new ApplicationApi();
